import React from 'react';
import {
  useCountry,
  useFeatureFlag,
  useIdentityValidation,
  useSyncKycFlags,
} from 'commons/hooks';
import { FeatureFlag } from 'commons/services';

/**
 * Runs the KYC flags sync once when mounted. Kept as a separate child so the
 * hook is only called when the app-load gating below allows it.
 */
const RunKycFlagsSync = (): null => {
  useSyncKycFlags();
  return null;
};

/**
 * Triggers the KYC flags sync at app load, only for Argentina merchants with a
 * pending KYC status and while the feature flag is on. It is mounted once in the
 * app shell (inside ContextWrapper), so the sync fires once per session.
 *
 * The IdentityValidationSteps screen keeps its own unconditional sync; this only
 * adds the earlier app-load trigger, gated by the flag during rollout.
 */
const KycFlagsSync = (): JSX.Element | null => {
  const { isArgentina } = useCountry();
  const { enabled: flagEnabled } = useFeatureFlag(
    FeatureFlag.FS_PAGONUBE_SYNC_FLAGS_AT_BEGINNING_ENABLED,
  );
  const { data: identityValidation } = useIdentityValidation({
    enabled: isArgentina && flagEnabled,
  });
  const isKycPending = identityValidation?.status === 'pending';

  return flagEnabled && isArgentina && isKycPending ? (
    <RunKycFlagsSync />
  ) : null;
};

export default KycFlagsSync;
